import { render, staticRenderFns } from "./dashboardGoalsComponent.vue?vue&type=template&id=69a113a5&scoped=true"
import script from "./dashboardGoalsComponent.vue?vue&type=script&lang=js"
export * from "./dashboardGoalsComponent.vue?vue&type=script&lang=js"
import style0 from "./dashboardGoalsComponent.vue?vue&type=style&index=0&id=69a113a5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a113a5",
  null
  
)

export default component.exports